<template>
  <div class="iz-ImageZoom_Wrapper" @mousemove="move" @mouseenter="zoom" @mouseleave="unzoom">
    <img
      ref="baseImage"
      class="iz-ImageZoom_BaseImage"
      :class="image_class"
      :src="base_image"
      :alt="alt"
    />
    <img
      v-if="active && zoom_image"
      ref="zoomImage"
      class="iz-ImageZoom_ZoomImage"
      :src="zoom_image || base_image"
      :alt="alt"
    />
  </div>
</template>

<script>
export default {
  name: "ImageZoomer",
  props: {
    base_image: {
      required: true,
      type: String,
    },
    zoom_image: {
      default: "",
      type: String,
    },
    alt: {
      required: true,
      type: String,
    },
    image_class: {
      default: "",
      type: String,
    },
    active: {
      type: Boolean,
    },
  },
  methods: {
    zoom() {
      if (this.showZoomImage()) {
        this.$refs.zoomImage.style.opacity = 1;
      }
    },
    unzoom() {
      if (this.showZoomImage()) {
        this.$refs.zoomImage.style.opacity = 0;
      }
    },
    move(e) {
      if (!this.showZoomImage()) {
        return false;
      }

      function pageOffset(el) {
        var rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
          y: rect.top + scrollTop,
          x: rect.left + scrollLeft,
        };
      }

      let offset = pageOffset(this.$el);
      let zoom = this.$refs.zoomImage;
      let base = this.$refs.baseImage;
      let relativeX = e.clientX - offset.x + window.pageXOffset;
      let relativeY = e.clientY - offset.y + window.pageYOffset;
      let baseFactorX = relativeX / base.offsetWidth;
      let baseFactorY = relativeY / base.offsetHeight;
      let x = baseFactorX * (zoom.offsetWidth - base.offsetWidth);
      let y = baseFactorY * (zoom.offsetHeight - base.offsetHeight);
      zoom.style.left = `${-x}px`;
      zoom.style.top = `${-y}px`;
    },
    showZoomImage() {
      if (!this.$refs.zoomImage) {
        return false;
      }

      return this.$refs.zoomImage.naturalWidth > this.$refs.baseImage.naturalWidth * 1.2;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.iz-ImageZoom_Wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iz-ImageZoom_BaseImage {
  max-width: 100%;
  background: $white;
  border-radius: $border-radius;
  cursor: pointer;
}

.iz-ImageZoom_Wrapper .iz-ImageZoom_BaseImage {
  max-width: 100%;
  border-radius: $border-radius;
}

.iz-ImageZoom_Wrapper .iz-ImageZoom_ZoomImage {
  border-radius: $border-radius;
  position: absolute;
  background: $white;
  opacity: 0;
  transform-origin: top left;
  max-width: 300%;
  transition: opacity 0.25s;
}
</style>
